import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance, ref } from 'vue';
import { ArticleV1 } from '@ilteducation/content-registry-types';
import DropFile from '@/components/base/DropFile.vue';
import eventBus from '@/foundations/services/eventBus';
import { createAudio } from '@/foundations/helpers/articleAudio';

type Props = {
  onSave?: (entries: object[]) => Promise<void>;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ArticleAudioImportButton',
  props: {
    onSave: null
  },
  setup(__props: any) {



const dialog = ref(false);

const store = ref<any>();

const useStore = () => {
  const vm = getCurrentInstance()!.proxy;
  store.value = vm.$store;
};
useStore();

const audioFiles = ref<File[]>([]);
const uploadActive = computed<boolean>(() => audioFiles.value.length > 0);
const dropFileRef = ref<InstanceType<typeof DropFile> | null>(null);

const handleFileChange = (files: File[]) => {
  audioFiles.value = files;
};

const uploadAudio = async (file: File) => {
  const articleId = file.name.split('.')[0];
  const res = await store.value.dispatch(`articles/getOne`, { id: articleId });
  if (res.status === 200 && res.data.type === 'ArticleV1') {
    await createAudio(res.data as ArticleV1, file);
    console.log(`Upload done for ${articleId}`);
    return { fName: file.name, result: true };
  }
  throw new Error('Article does not exist');
};

const triggerUploadFiles = async () => {
  const totalCount = audioFiles.value.length;
  console.log(`Uploading ${totalCount} rows`);
  eventBus.$emit('snackbar.open', `Import of ${audioFiles.value.length} rows started.`);
  const res = await Promise.allSettled(audioFiles.value.map((file) => uploadAudio(file)));

  const okCount = res.filter((b) => b.status === 'fulfilled').length;
  res.filter((b) => b.status === 'fulfilled').forEach((uRes) => dropFileRef.value?.removeFileName(uRes.value.fName));
  eventBus.$emit('snackbar.open', `Import finished, ${okCount} successfully imported of ${totalCount}`);
};
const validFileName = async (fName: string) => {
  const name = fName.split('.')[0];
  return name.length === 12 || name.length === 21;
};

return { __sfc: true,dialog, store, useStore, audioFiles, uploadActive, dropFileRef, handleFileChange, uploadAudio, triggerUploadFiles, validFileName, DropFile }
}

})